import { createFileRoute } from '@tanstack/react-router'
import { listCampaigns } from '~/lib/content/content'
import type { CampaignEntry } from '~/lib/content/content'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { ContentCard } from '~/components/ui/ContentCard'
import { Container } from '~/components/ui/Container'
import { DonateSignupBand } from '~/components/sections/DonateSignupBand'
import { PageTitle } from '~/components/ui/PageTitle'
import { pageTop } from '~/components/ui/PageHero'

const TITLE = 'Campaigns | Direct Action Everywhere'
const DESCRIPTION =
  'Our campaigns are designed to grab media attention, generate conversation, disrupt speciesism, and secure instrumental and symbolic victories for animals.'

export const Route = createFileRoute('/campaigns/')({
  loader: () => listCampaigns(),
  headers: () => cacheHeaders.content,
  head: () => pageMeta({ title: TITLE, description: DESCRIPTION }),
  component: Campaigns,
})

function Campaigns() {
  const campaigns = Route.useLoaderData()
  return (
    <>
      <div className="pb-[100px] max-md:pb-10">
        <Container className={pageTop}>
          <PageTitle className="mb-5 text-center">Our Campaigns</PageTitle>
          <p className="mx-auto mb-10 max-w-3xl text-center text-sm leading-6 md:mb-12 md:text-base md:leading-[26px]">
            Our campaigns are designed to grab media attention, generate
            conversation, disrupt speciesism, secure instrumental and symbolic
            victories, and move us along our{' '}
            <a
              href="https://dxe.io/roadmap"
              target="_blank"
              rel="noreferrer"
              className="font-bold text-accent hover:underline"
            >
              Roadmap to an Animal Bill of Rights
            </a>
            . Here’s what we’re working on now:
          </p>
          <ul className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {campaigns.map((c) => (
              <li key={c.slug}>
                <CampaignCard campaign={c} />
              </li>
            ))}
          </ul>
        </Container>
      </div>
      <DonateSignupBand />
    </>
  )
}

function CampaignCard({ campaign: c }: { campaign: CampaignEntry }) {
  return (
    <ContentCard
      {...(c.href
        ? { href: c.href }
        : { to: { to: '/campaigns/$slug', params: { slug: c.slug } } })}
      image={c.image}
      title={c.title}
      summary={c.summary}
    />
  )
}
